import Web3 from 'web3';

export const declareGlobalProvider = (provider: any) => {
	window.myProvider = provider;
};

export const declareGlobalWeb3 = (provider: any) => {
	window.myWeb3 = new Web3(provider);
};
